export default "__VITE_ASSET__DEmnxknF__"